"use strict";

exports.__esModule = true;
exports.getEnabledPlantStateActivities = getEnabledPlantStateActivities;
var _PlantStateActivitiesContext = require("./PlantStateActivitiesContext");
function getEnabledPlantStateActivities(context) {
  var _result$activities, _result$mapping;
  var result = Object.assign({}, context);
  result.activities = (_result$activities = result.activities) == null ? void 0 : _result$activities.filter(function (activity) {
    return activity.isEnabled;
  });
  result.mapping = (_result$mapping = result.mapping) == null ? void 0 : _result$mapping.filter(function (map) {
    map.activities = map.activities.filter(function (activityMap) {
      return result.activities.find(function (act) {
        return act.id === activityMap.id;
      });
    });
    return true;
  });
  return result;
}